/**
 * Created by CoolGuy on 2017/7/24.
 */
import { connect } from "react-redux";
import { Subject, tap, timeInterval } from "rxjs";
import React, { useEffect, useState } from "react";
import { Icon, message, Modal, Upload } from "antd";

import { Image } from "@/util/ApiList";
import { download, formatSign, getPhotoSrc, beforeUpload } from "@/util/image";

const { store } = Image;
const ImageStoreUrl = store.url;


/**
 * 根据时间间隔获取新的Subject
 *
 * 在上传的时候比较有用, 因为onChange频繁触发,
 * 但是我们只需要获取到第一次触发的点,后面的都丢弃
 *
 * @param subject
 * @param debounceTime
 * @returns {{subject: Subject<unknown>, subscriber: *}}
 */
export function getNewSubjectByDebounceTime(subject, debounceTime = 1000) {
  const newSubject = new Subject();

  const subscriber = subject
    .pipe(
      timeInterval(),
      tap((valueWithInterval) => {
        let { interval, value } = valueWithInterval;
        if (interval > debounceTime) {
          newSubject.next(value);
        }
      })
    )
    .subscribe(() => {});

  return {
    subject: newSubject,
    subscriber,
  };
}

export const useFirstValueDependingOnDebounceTime = ({
  subject,
  debounceTime = 1000,
}) => {
  const [newSubject, setNewSubject] = useState(() => new Subject());

  useEffect(() => {
    const { subject: _subject, subscriber } = getNewSubjectByDebounceTime(
      subject,
      debounceTime
    );

    setNewSubject(_subject);

    return () => {
      if (subscriber) {
        subscriber.unsubscribe();
      }
    };
  }, [subject, debounceTime]);
  return newSubject;
};

const handleFileList = (fileList) => {
  if (!fileList) return;
  if (typeof fileList == "string") {
    fileList = fileList.split(",");
  }
  return fileList.map((one) => {
    if (typeof one === "string") {
      let theKey = one;
      return {
        uid: Math.random().toString().slice(2, 8),
        key: theKey,
        // thumbUrl:getPhotoSrc({photo:theKey}),
        url: getPhotoSrc({ photo: theKey }, false),
        status: "done",
      };
    }
    return one;
  });
};

class MultiUpload extends React.Component {
  // 构造
  constructor(props) {
    super(props);
    // 初始状态
    this.state = {
      previewVisible: false,
      previewImage: "",
      fileList: handleFileList(props.fileList) || [],
      limitSize: 20,
      //一个可能的fileList的file格式如下
      // {
      //     uid: -1,
      //     name: 'xxx.png',
      //     status: 'done',
      //     url: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',
      //     key:"....."
      // }
    };
  }

  //注意有时候可能是刚初始化
  componentWillReceiveProps(nextProps) {
    //console.log("I received",nextProps);
    let { fileList } = nextProps;
    //需要考虑是否要预处理
    if (fileList) {
      fileList = handleFileList(fileList);
    }

    let newProps = Object.assign({}, nextProps);
    newProps.fileList = fileList;

    this.setState(newProps);
  }

  handleCancel = () => this.setState({ previewVisible: false });

  handlePreview = async (file) => {
    let { url, name } = file;
    if (url.match(/(jpg|jpeg|png|gif)$/)) {
      this.setState({
        previewImage: file.url || file.thumbUrl,
        previewVisible: true,
      });
    } else {
      // window.open(url, '_blank');
      const hide = message.loading("下载中，请勿重复点击", 0);
      await download(url, name);
      hide();
    }
  };

  handleChange = (info) => {
    let { fileList, file } = info;

    if (file && file.status !== "removed") {
      if (fileList.length) {
        let lastFile = fileList[fileList.length - 1];
        lastFile.key = this.uploadParam.key;
        // lastFile.thumbUrl = getPhotoSrc({photo:lastFile.key});
        lastFile.url = getPhotoSrc({ photo: lastFile.key }, false);
      }
      this.setState({ fileList }, () => {
        let { uploadFinish } = this.props;
        uploadFinish && uploadFinish(fileList);
      });
    }
  };
  uploadParam = {};
  formatSign = (sign) => {
    return Object.assign(this.uploadParam, formatSign(sign));
  };
  beforeUpload = (file) => {
    return beforeUpload(file, this.props.directory, this.props.limitSize).then(
      (key) => {
        this.uploadParam.key = key;
        //console.log(key);
      }
    );
  };

  handleRemove = (info) => {
    const that = this;

    return new Promise((resolve) => {
      Modal.confirm({
        title: "请确认是否删除此内容，删除该信息请慎重?",
        onOk() {
          let newList = that.state.fileList.filter((one) => {
            return one.key !== info.key;
          });

          that.setState(
            {
              fileList: newList,
            },
            () => {
              let { uploadFinish } = that.props;
              uploadFinish && uploadFinish(newList);
            }
          );

          resolve(true);
        },
        onCancel() {
          resolve(false);
        },
        zIndex: 1036,
      });
    });
  };
  render() {
    let { previewVisible, previewImage, fileList } = this.state;
    let { image } = this.props;
    if (!image || !image.sign) {
      return null;
    }
    //console.log(fileList);
    fileList = fileList || [];

    const uploadButton = this.props.uploadButton ? (
      this.props.uploadButton
    ) : (
      <div>
        <Icon type="plus" />
        <div className="ant-upload-text">上传</div>
      </div>
    );
    return (
      <div
        className={
          "clearfix multi-upload " + (this.props.disabled ? "disabled" : "")
        }
      >
        <div className="avatar-uploader-tip">{this.props.tip}</div>
        <Upload
          action={ImageStoreUrl}
          listType={this.props.listType || "picture-card"}
          fileList={fileList}
          onPreview={this.handlePreview}
          onRemove={this.handleRemove}
          data={this.formatSign(image.sign)}
          beforeUpload={this.beforeUpload}
          onChange={this.handleChange}
          disabled={this.props.disabled}
          multiple={this.props.multiple}
          showUploadList={{
            showPreviewIcon: true,
            showRemoveIcon: true,
            showDownloadIcon: true,
            downloadIcon: <Icon type="download" style={{ fontSize: "16px" }} />,
          }}
          onDownload={(file) => {
            if (file.status !== "done") {
              return;
            }
            const hide = message.loading("下载中", 1000);
            download(file.url, file.name).then(() => {
              hide();
            });
          }}
        >
          {fileList.length >= (this.props.maxCount || 10) || this.props.disabled
            ? null
            : uploadButton}
        </Upload>
        <Modal
          visible={previewVisible}
          footer={null}
          onCancel={this.handleCancel}
          zIndex={1035}
        >
          <img alt="example" style={{ width: "100%" }} src={previewImage} />
        </Modal>
      </div>
    );
  }
}

export default connect((state) => ({
  image: state.image,
}))(MultiUpload);



// WEBPACK FOOTER //
// ./src/components/Common/MultiUpload.js